import "../SurveyStatsCards.css";

export default function FilteredStatsBox({
  summary,
  filteredResp,
  invites,
  responses,
  unAnswered,
}) {

  const getResponseColor = (rate) => {
  if (rate >= 80) return "#0ac213"; // grön
  if (rate >= 65) return "#4b7d2e"; // grön
  if (rate >= 50) return "#bb8735"; // gul
  return "#a72e2e"; // röd
};

  const employeeIds = Array.from(
    new Set([
      ...invites.map((i) => i.employeeId),
      ...responses.map((r) => r.employeeId),
    ]),
  ).filter(Boolean);

const employeeStats = employeeIds
  .map((employeeId) => {
    const employeeInvites = invites.filter((i) => i.employeeId === employeeId);

    const employeeResponses = responses.filter(
      (r) => r.employeeId === employeeId
    );

    const employeeDirectResponses = responses.filter(
      (r) => r.employeeId === employeeId && !r.inviteToken
    );

    const contacted =
      employeeInvites.length + employeeDirectResponses.length;

    const responseRate =
      contacted > 0
        ? Math.round((employeeResponses.length / contacted) * 100)
        : 0;

    return {
      employeeId,
      responses: employeeResponses.length,
      invites: employeeInvites.length,
      directResponses: employeeDirectResponses.length,
      contacted,
      responseRate,
    };
  })
  .sort((a, b) => {
    // sortera på svarsfrekvens (högst först)
    if (b.responseRate !== a.responseRate) {
      return b.responseRate - a.responseRate;
    }

    // fallback: flest svar först
    return b.responses - a.responses;
  });

  return (
    <div
      style={{
        marginTop: "1em",
        padding: "1em",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        border: "1px solid #ccc",
      }}
    >
      <h3>Sammanfattning</h3>
      <p>
        <strong>Totalt antal svar:</strong> {filteredResp.length} {"("}av{" "}
        {summary.totalResponses}
        {")"}
      </p>
      <p>
        <strong>Unika anställda:</strong>{" "}
        {Object.keys(summary.employees).length}
      </p>
      <ul style={{ marginTop: 0, marginBottom: "1em" }}>      
        <div className="employeeStatsGrid">
          {employeeStats.map((emp) => (
           <div className="employeeStatsCard" key={emp.employeeId}>
  <div className="employeeStatsHeader">
    <strong>{emp.employeeId}</strong>
    <span
      style={{
        color: getResponseColor(emp.responseRate),
        fontWeight: "700",
      }}
    >
      {emp.responseRate}%
    </span>
  </div>

  <p>{emp.responses} svar</p>

  <small>
    {emp.contacted} kontaktade
    {emp.directResponses > 0 && <> · {emp.directResponses} direkt</>}
  </small>
</div>
          ))}
        </div>
      </ul>
      <p>
        <strong>Kontor:</strong> {Object.keys(summary.offices).length}
      </p>
      <ul style={{ marginTop: 0, marginBottom: "1em" }}>
        {Object.entries(summary.offices).map(([empId, count]) => (
          <li key={empId}>
            {empId}: {count} svar
          </li>
        ))}
      </ul>
      <p>
        <strong>Undersökningsperiod:</strong>{" "}
        {summary.fromDate?.toLocaleDateString()} –{" "}
        {summary.toDate?.toLocaleDateString()}
      </p>
    </div>
  );
}
